export default __webpack_public_path__ + "static/media/done-activities-icon.a01f81c6.svg";